export default {
  namespaced: true,
  state: {
    roles: [
      'ROLE_CLIENT',
      'ROLE_COMPTA',
      'ROLE_COMMERCIAL',
      'ROLE_ADMIN'
    ],
    operations: [
      'CREDIT',
      'WITHDRAWAL'
    ],
    periods: [
      'day',
      'week',
      'month',
      'year'
    ]
  },
  getters: {
    roles: state => {
      return state.roles
    },
    periods: state => {
      return state.periods
    },
    operations: state => {
      return state.operations
    }
  }
}
